import { observer } from 'mobx-react-lite';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { CommonLink } from '../views/common/CommonLink';
import { GuideIconButton } from '../views/common/GuideButton';

const BoxTitle = observer(
    ({
        title,
        guideDocKey,
        className,
    }: {
        title: string;
        /**
         * 제목에 가이드 문서 링크를 추가할 때 사용
         */
        guideDocKey?: string;
        className?: string;
    }) => {
        return (
            <h3
                className={twMerge(
                    'text-base-content/70 -mt-2.5 mb-3 flex min-h-8.5 items-center text-sm font-semibold',
                    className,
                )}
            >
                {title}
                {guideDocKey && <GuideIconButton docKey={guideDocKey} />}
            </h3>
        );
    },
);

const BoxMore = observer(({ link, children }: { link: string; children: React.ReactNode }) => {
    return (
        <footer className="border-base-300 -mx-5 mt-4 -mb-5 border-t">
            <CommonLink
                className="text-base-content/60 textarea-md flex h-12 w-full items-center justify-center text-center"
                to={link}
                preventScrollReset={false}
            >
                {children}
            </CommonLink>
        </footer>
    );
});

/**
 * 프레임 내부에 그리는 박스 레이아웃
 * 제목(링크), 내용, 하단 더보기 영역(링크)로 구성됨
 */
const Box = Object.assign(
    observer(
        ({
            children,
            className,
            isLoading = false,
            noBorder = false,
            ...rest
        }: {
            children?: React.ReactNode;
            className?: string;
            isLoading?: boolean;
            noBorder?: boolean;
        } & React.HTMLAttributes<HTMLElement>) => {
            return (
                <section {...rest} className={twMerge('bg-base-100 relative px-5 py-5', className)}>
                    {isLoading ? (
                        <div className="flex flex-col gap-3">
                            <div className="skeleton h-4.5 w-full rounded-sm" />
                            <div className="skeleton h-4.5 w-full rounded-sm" />
                            <div className="skeleton h-4.5 w-full rounded-sm" />
                        </div>
                    ) : (
                        children
                    )}

                    {/* 보더에 의해 여백이 변경되는 것을 방지하기 위해 absolute 로 추가함 */}
                    {!noBorder && (
                        <div className="border-base-300 pointer-events-none absolute inset-0 z-1 border"></div>
                    )}
                </section>
            );
        },
    ),
    {
        Title: BoxTitle,
        More: BoxMore,
    },
);

export default Box;
